module.exports = __webpack_public_path__ + "assets/img/koennecke-2.e7044c80.png";